import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const NINE_HOLE_PEG_TEST_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.NINE_HOLE_PEG_TEST_SCALE,
  title: 'Nine-Hole Peg Test (9HPT)',
  scoreConfig: {
    scoreKey: 'media_tempi',
    scoreFields: ['tempo_mano_dominante', 'tempo_mano_non_dominante'],
  },
  sections: [
    {
      name: '9hpt',
      label: 'Nine-Hole Peg Test (9HPT)',
      fields: [
        {
          key: 'tempo_mano_dominante',
          label: 'Tempo mano dominante (secondi)',
          type: 'number',
          min: 0,
          max: 120,
          step: 0.1,
          maxScore: 120,
          description:
            'Tempo in secondi per inserire e rimuovere i 9 pioli usando la mano dominante.',
        },
        {
          key: 'tempo_mano_non_dominante',
          label: 'Tempo mano non dominante (secondi)',
          type: 'number',
          min: 0,
          max: 120,
          step: 0.1,
          maxScore: 120,
          description:
            'Tempo in secondi per inserire e rimuovere i 9 pioli usando la mano non dominante.',
        },
      ],
    },
  ],
  computedFields: [
    {
      key: 'interpretazione',
      label: 'Interpretazione',
      type: 'text',
      calculation: `
        IF(media_tempi <= 25, "Destrezza e motricità fine nella norma",
          IF(media_tempi <= 40, "Prestazione rallentata",
            "Prestazione gravemente rallentata"
          )
        )
      `,
      maxScore: null,
    },
  ],
};
